import { createRouter, createWebHashHistory } from "vue-router";

const Activity = () => import("../views/Activity");
const Activity1 = () => import("../views/Activity/Template/v1");
const Activity2 = () => import("../views/Activity/Template/v2");
const Share = () => import("../views/Share");
const Page404 = () => import("../views/error/404.vue");
const ChildAgreement = () => import("../views/ChildAgreement");
const PrivateAgreement = () => import("../views/PrivateAgreement");
const UserAgreement = () => import("../views/UserAgreement");
const AttendanceNotice = ()=>import("../views/AttendanceNotice");
const cc = ()=>import("../views/cc");
const ReachOrLeaveNotice = ()=>import('../views/ReachOrLeaveNotice');
const ChildrenAgreement = () => import("../views/ChildrenAgreement");
const MessageAuth = () => import("../views/MessageAuth");
const InterestShowSharing = () => import('../views/InterestShowSharing/index.vue')
const routes = [
  {
    path: "/activity",
    name: "Activity",
    component: Activity,
  },  {
    path: "/interestShowSharing",
    name: "InterestShowSharing",
    component: InterestShowSharing,
  },
  {
    path: "/attendanceNotice",
    name: "AttendanceNotice",
    component: AttendanceNotice,
  },
  {
    path: "/activity/v1",
    name: "Activity1",
    component: Activity1,
  }, {
    path: "/reachOrLeaveNotice",
    name: "ReachOrLeaveNotice",
    component: ReachOrLeaveNotice,
  },
  {
    path: "/activity/v2",
    name: "activity2",
    component: Activity2,
  },
  {
    path: "/share",
    name: "share",
    component: Share,
  },
  {
    path: "/child",
    name: "child",
    component: ChildAgreement,
  },
  {
    path: "/private",
    name: "private",
    component: PrivateAgreement,
  },
  {
    path: "/user",
    name: "user",
    component: UserAgreement,
  },{
    path: "/cc",
    name: "cc",
    component: cc,
  },{
    path: "/childrenAgreement",
    name: "childrenAgreement",
    component: ChildrenAgreement,
  },{
    path: "/MessageAuth",
    name: "MessageAuth",
    component: MessageAuth,
  },

  {
    path: "/error404",
    name: "error404",
    component: Page404,
  },
  { path: "/:pathMath(.*)", redirect: "/error404" },
];

const router = createRouter({
  history: createWebHashHistory(),
  routes,
});

export default router;
